module.exports = __webpack_public_path__ + "img/photo-0047.8794f717.jpg";